/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The APIOKMsgResponse model module.
 * @module model/APIOKMsgResponse
 * @version v1
 */
class APIOKMsgResponse {
    /**
     * Constructs a new <code>APIOKMsgResponse</code>.
     * @alias module:model/APIOKMsgResponse
     * @param success {Boolean} 
     */
    constructor(success) { 
        
        APIOKMsgResponse.initialize(this, success);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, success) { 
        obj['Success'] = success;
    }

    /**
     * Constructs a <code>APIOKMsgResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/APIOKMsgResponse} obj Optional instance to populate.
     * @return {module:model/APIOKMsgResponse} The populated <code>APIOKMsgResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new APIOKMsgResponse();

            if (data.hasOwnProperty('Success')) {
                obj['Success'] = ApiClient.convertToType(data['Success'], 'Boolean');
            }
            if (data.hasOwnProperty('Message')) {
                obj['Message'] = ApiClient.convertToType(data['Message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>APIOKMsgResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>APIOKMsgResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of APIOKMsgResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['Message'] && !(typeof data['Message'] === 'string' || data['Message'] instanceof String)) {
            throw new Error("Expected the field `Message` to be a primitive type in the JSON string but got " + data['Message']);
        }

        return true;
    }


}

APIOKMsgResponse.RequiredProperties = ["Success"];

/**
 * @member {Boolean} Success
 */
APIOKMsgResponse.prototype['Success'] = undefined;

/**
 * @member {String} Message
 */
APIOKMsgResponse.prototype['Message'] = undefined;






export default APIOKMsgResponse;

